import { Link } from 'react-router-dom';

/**
 * 页脚：一条铭牌线。
 * 链接的静止/悬停色和 RackNav 用同一套（bone/45 → bone），页脚不该自己发明一套
 * 更暗的灰——同一台机器上的两处导航，手感要一样。
 * 四个目标页（支持 / 隐私 / 条款 / Cookie）已统一到 DocShell 的深色版式。
 */
export default function RackFooter() {
  return (
    <footer className="border-t border-rack-bone/[0.08] bg-rack-ground">
      <div className="mx-auto flex max-w-[1180px] flex-col gap-5 px-6 py-9 sm:flex-row sm:items-center sm:justify-between sm:px-10">
        <div className="flex items-center gap-2.5">
          <img
            src="/brand/avatar.webp"
            alt=""
            width={22}
            height={22}
            loading="lazy"
            className="h-[22px] w-[22px] rounded-[3px] border border-rack-bone/12 object-cover"
          />
          <span className="text-[12px] text-rack-bone/55">阳仔AI</span>
          <span className="font-readout text-[10px] tracking-[0.16em] text-rack-bone/22">
            minddock.ai
          </span>
        </div>

        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2" aria-label="页脚导航">
          {[
            ['/support', '支持'],
            ['/privacy', '隐私政策'],
            ['/terms', '服务条款'],
            ['/cookies', 'Cookie'],
          ].map(([href, label]) => (
            <Link
              key={href}
              to={href}
              className="text-[11.5px] text-rack-bone/45 transition-colors hover:text-rack-bone focus-visible:text-rack-bone focus-visible:outline-none"
            >
              {label}
            </Link>
          ))}
        </nav>

        <p className="font-readout text-[10px] tracking-[0.16em] text-rack-bone/22">
          © {new Date().getFullYear()} SOLO
        </p>
      </div>
    </footer>
  );
}
